import { bsc, bscTestnet } from '@reown/appkit/networks'

import { NETWORK } from './env'

export const BSC_CHAIN = {
  mainnet: bsc,
  testnet: bscTestnet,
}[NETWORK as 'mainnet' | 'testnet']
